import { useState, useCallback, useMemo } from 'react'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { TopicComparisonWidgetType } from '../../../types'
import { convertToInsightContentSetting, addSelectionFilterToWidgetSetting } from '../utils'

const useSelectedInsights = (widgetSetting: TopicComparisonWidgetType) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedInsights, setSelectedInsights] = useState<InsightData[]>([])

  const detailSetting = useMemo(
    () =>
      convertToInsightContentSetting(widgetSetting, {
        insights: selectedInsights
      }),
    [widgetSetting, selectedInsights]
  )

  const widgetSettingWithSelection = useMemo(
    () =>
      addSelectionFilterToWidgetSetting(widgetSetting, {
        insights: selectedInsights
      }),
    [widgetSetting, selectedInsights]
  )

  const onClick = useCallback(
    (insightData: InsightData) => {
      setIsModalOpen(true)
      setSelectedInsights([insightData])
    },
    [setIsModalOpen, setSelectedInsights]
  )

  const onClose = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return {
    isModalOpen,
    selectedInsights,
    onClick,
    onClose,
    detailSetting,
    widgetSettingWithSelection
  }
}

export default useSelectedInsights
